module.exports = __webpack_public_path__ + "6f6f664e4b4a74fd58b29782960076e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/nature/Beach1.jpg
// module id = 3544
// module chunks = 0